export default __webpack_public_path__ + "static/media/founder3.4992f3a7.png";